import jwt_decode from "jwt-decode";
import Cookies from 'js-cookie';
import AuthAdminUserModel from "../models/AuthAdminUserModel";

const tokenName: string = "ccl-admin-token";

class Auth {
    static unathorizedRequestEventFunctions: Function[] = [];

    subscribeForUnathorizedRequest(onUnathorizedRequestEvent: Function) {
        Auth.unathorizedRequestEventFunctions.push(onUnathorizedRequestEvent);
    }

    triggerUnathorizedRequest() {
        for (let i = 0; i < Auth.unathorizedRequestEventFunctions.length; i++) {
            try {
                Auth.unathorizedRequestEventFunctions[i]();
            } catch (ex) {
                console.log("unathorizedRequestEvent exception: " + ex);
            }
        }
    }

    getAuthToken() {
        return Cookies.get(tokenName);
    }

    setAuthToken(token: string) {
        return Cookies.set(tokenName, token, { expires: 30 });
    }

    deleteAuthToken() {
        Cookies.remove(tokenName);
    }

    getDecodedToken(): AuthAdminUserModel | null {
        const token = this.getAuthToken();
        if (!!token) {
            var decodedItem: AuthAdminUserModel = jwt_decode(token);
            if (decodedItem != null) {
                // need to create the object in order to get a protoype version of the object
                var result = new AuthAdminUserModel();
                result.id = parseInt(`${decodedItem.id}`, 10);
                result.name = decodedItem.name;
                result.cid = decodedItem.cid?.toUpperCase();
                result.company = decodedItem.company?.toUpperCase();
                result.role = decodedItem.role;
                result.comp = decodedItem.comp;
                result.ver = decodedItem.ver;
                return result;
            }
        } return null;

    }
}

export default new Auth();

